export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14612.d41aa198.jpg";